export default {
    namespaced: true,
    state: {
        users: []
    },
    getters: {
        users: (state) => {
            return state.users;
        }
    },
    actions: {

    },
    mutations: {
        users (state, users) {
            state.users = users;
        }
    }
}